export default __webpack_public_path__ + "static/doordash-b9f2417b80af1e5bfd32c2625fe9f354.png";